<section class="bg-white border border-solid p-6 rounded-lg flex items-center h-[19rem] md:h-48 lg:h-32 relative">
    <!-- z-10 right-6 left-6 md:right-8 md:left-8 lg:right-[3.5rem] lg:left-[3.5rem] -->
    <ul class="flex items-center flex-col md:flex-row gap-6 md:gap-0 flex-wrap flex-grow">
        <li class="flex items-center gap-2 w-full justify-start md:w-1/2 lg:flex-grow-0" [ngClass]="{'lg:w-2/6': accommodation() == 'ecolodge', 'lg:w-1/4': accommodation() !== 'ecolodge'}">
            <img [ngSrc]="cdnUrl + '/images/footer-features-icons-1.png'" width="60" height="60" alt="رزرو 100 درصد آنلاین">
            <div class="flex flex-col gap-1 border-r-2 pr-2  border-solid border-metal-50">
                <p class="font-bold">رزرو 100 درصد آنلاین</p>
                <span class="text-muted text-sm">رزرو 100 درصد آنلاین بیش از 1900 هتل</span>
            </div>
        </li>
        <li class="flex items-center gap-2 w-full justify-start md:w-1/2 lg:flex-grow-0" [ngClass]="{'lg:w-2/6': accommodation() == 'ecolodge', 'lg:w-1/4': accommodation() !== 'ecolodge'}">
            <img [ngSrc]="cdnUrl + '/images/footer-features-icons-4.png'" width="60" height="60" alt="مشاوره نیم میلیونی">
            <div class="flex flex-col gap-1 border-r-2 pr-2 border-solid border-metal-50">
                <p class="font-bold">مشاوره نیم میلیونی</p>
                <span class="text-muted text-sm">بزرگترین مرجع نظرات هتل ها</span>
            </div>
        </li>
        <li class="flex items-center gap-2 w-full justify-start md:w-1/2 lg:flex-grow-0 md:mt-6 lg:mt-0" [ngClass]="{'lg:w-2/6': accommodation() == 'ecolodge', 'lg:w-1/4': accommodation() !== 'ecolodge'}"
        >
            <img [ngSrc]="cdnUrl + '/images/footer-features-icons-3.png'" width="60" height="60" alt="گارانتی کمترین قیمت">
            <div class="flex flex-col gap-1 border-r-2 pr-2 border-solid border-metal-50">
                <p class="font-bold">گارانتی کمترین قیمت</p>
                <span class="text-muted text-sm">رزرو هتل با بیشترین تخفیف</span>
            </div>
        </li>
        <ng-container *ngIf="accommodation() !== 'ecolodge'">
            <li class="flex items-center gap-2 w-full justify-start md:w-1/2 lg:flex-grow-0 lg:w-1/4 md:mt-6 lg:mt-0">
                <img [ngSrc]="cdnUrl + '/images/footer-features-icons-2.png'" width="60" height="60" alt="کارمزد کنسلی رایگان">
                <div class="flex flex-col gap-1 border-r-2 pr-2 border-solid border-metal-50">
                    <p class="font-bold">کارمزد کنسلی رایگان</p>
                    <span class="text-muted text-sm">کارمزد کنسلی صفر درصد</span>
                </div>
            </li>
        </ng-container>
    </ul>
</section>